import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CompanyService } from 'src/app/services/company.service';

@Component({
  selector: 'app-add-partner-modal',
  templateUrl: './add-partner-modal.component.html',
  styleUrls: ['./add-partner-modal.component.scss']
})
export class AddPartnerModalComponent {

  formsPartner!: FormGroup;
  qualificationList = this.companyService.qualificationList;
  bool = false;
  @Output() add = new EventEmitter(false);

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<AddPartnerModalComponent>,
    private companyService: CompanyService,
  ) {
    this.formsPartner = this.formBuilder.group({
      cpf: [null, Validators.required],
      name: [null, [Validators.required, Validators.pattern(/^[A-Za-zÀ-ÖØ-öø-ÿ0-9 .]+$/)]],
      phone: [null, Validators.required],
      mail: [null, [Validators.required, Validators.email, Validators.pattern(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.(com|com\.br)$/i)]],
      qualificationCode: [null, Validators.required],
      isSolidaryPartner: [false],
      isSubscriber: [false]
    })
  };

  save() {
    this.sanitizeName();
    this.normalizeEmailOnSave();

    if (!this.formsPartner.valid) return;
    this.add.emit(this.formsPartner.value);
    this.dialogRef.close();
  }

  allowOnlyLetters(event: KeyboardEvent): void {
    const allowedPattern = /^[A-Za-zÀ-ÖØ-öø-ÿ0-9 .]$/;
    if (event.key.length === 1 && !allowedPattern.test(event.key)) {
      event.preventDefault();
    }
  }

  onMailInput(event: Event): void {
    const control = this.formsPartner.get('mail');
    if (!control) {
      return;
    }

    const cleaned = String((event.target as HTMLInputElement).value ?? '')
      .replace(/[^A-Za-z0-9@._%+-]/g, '');

    if (control.value !== cleaned) {
      control.setValue(cleaned, { emitEvent: false });
    }
  }

  onMailBlur(): void {
    const control = this.formsPartner.get('mail');
    if (control) {
      control.setValue(this.normalizeEmail(control.value), { emitEvent: false });
    }
  }

  sanitizeName(): void {
    const control = this.formsPartner.get('name');
    if (!control) return;

    const cleaned = String(control.value ?? '').replace(/[^A-Za-zÀ-ÖØ-öø-ÿ0-9 .]+/g, '');
    if (control.value !== cleaned) {
      control.setValue(cleaned, { emitEvent: false });
    }
  }

  private normalizeEmailOnSave(): void {
    const control = this.formsPartner.get('mail');
    if (control) {
      control.setValue(this.normalizeEmail(control.value), { emitEvent: false });
    }
  }

  private normalizeEmail(value: string | null | undefined): string {
    const email = String(value ?? '').replace(/<[^>]*>/g, '').trim().toLowerCase();
    const cleaned = email.replace(/[^a-z0-9@._%+-]/g, '');
    const parts = cleaned.split('@');
    return parts.length <= 1 ? cleaned : `${parts[0]}@${parts.slice(1).join('')}`;
  }

}
